import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThumbsUp"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6156 2H10.5427L6.42148 10H2V21H17.422C19.2752 21 20.8505 19.6463 21.1293 17.8142L21.9663 12.3142C22.3117 10.0444 20.5548 8 18.2589 8H13.8921L14.3328 5.17364C14.5928 3.50611 13.3033 2 11.6156 2ZM6 11.5V19.5H3.5V11.5H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbsUp;
